module.exports = __webpack_public_path__ + "img/EO4.5865a827.png";